import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import PurchaseDetails from "./PurchaseDetails";
import ShippingPopup from "./ShippingPopup";
import ProductPopUp from "./ProductPopUp";
import "./dashbord.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { PersonalInfoSkeletonLoading } from "../home/AllCategory/Skeleton";
import { MyContextSupply } from "../../Context";
import { useNavigate } from "react-router-dom";
import UpdateProfile from "./UpdateProfile";
import DeleteAccountPopUp from "./DeleteAccountPopUp";
import { toast } from "react-toastify";

const Personalinfo = () => {
  const {
    isProfileInfoLoading,
    account,
    token,
    setAccount,
    setAdminValidationRun,
    setAllUseEffectRunCode,
  } = MyContextSupply();
  const navigate = useNavigate();
  const [updateAccountInfo, setUpdateAccountInfo] = useState({
    fname: "",
    lname: "",
    email: "",
    mobile: "",
    password: "",
    newpassword: "",
  });

  const [isClickedForUpdate, setIsClickedForUpdate] = useState(false);
  const [isClickedToDelete, setIsClickedToDelete] = useState(false);

  const [isShippingPopUpOpen, setIsShippingPopUpOpen] = useState(false);
  const [isProductDetailsPopUpOpen, setisProductDetailsPopUpOpen] =
    useState(false);
  const [shippingDetails, setShippingDetails] = useState("");
  const [productDetails, setProductDetails] = useState("");

  // console.log(token)

  // delete user account
  const DeleteAccount = async () => {
    await axios
      .delete("https://stechbackend-9r4c.onrender.com/delete/current/user", {
        headers: { Authorization: token },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 2000,
          });
          localStorage.removeItem("tokens");
          localStorage.removeItem("isAdmin");
          localStorage.removeItem("isValidateAdmin");
          setAdminValidationRun(2);
          setAllUseEffectRunCode(2);
          setAccount("");
          navigate("/");
        }
      })
      .catch((error) => {
        const message = error.response.data.message;
        if (error) {
          toast.warn(message, {
            position: "top-center",
            autoClose: 2000,
          });
        }
      });
  };

  useEffect(() => {
    const { fname, lname, email, mobile } = account;
    setUpdateAccountInfo({
      fname: fname,
      lname: lname,
      email: email,
      mobile: mobile,
      password: "",
      newpassword: "",
    });
  }, [isClickedForUpdate]);

  return (
    <div className="purchase-container">
      <div className="profile-section">
        <h2>Personal Info</h2>
        {isProfileInfoLoading ? (
          <PersonalInfoSkeletonLoading />
        ) : (
          <div className="box-container-model ">
            <Avatar
              className="avtar-personalinfo"
              id="basic-button"
              aria-haspopup="true"
            >
              {account && account.fname[0]?.toUpperCase()}
            </Avatar>

            <h2 className="h4-avatar">{account && account.fname}</h2>
            <h4 className="h4-avatar last-name">{account && account.lname}</h4>
            <div className="personal-info-email-phone">
              <span>Email: {account && account.email}</span>
              <span>Phone: {account && account.mobile}</span>
            </div>
            <div className="profile_Action_buttons">
              <button
                onClick={() => setIsClickedForUpdate(true)}
                className="edit-profile-icon"
              >
                Edit Account <AiFillEdit />
              </button>
              <button
                onClick={() => setIsClickedToDelete(true)}
                className="edit-profile-icon"
              >
                Delete Account <AiFillDelete />
              </button>
            </div>
          </div>
        )}
      </div>
      <PurchaseDetails
        account={account}
        setIsShippingPopUpOpen={setIsShippingPopUpOpen}
        setisProductDetailsPopUpOpen={setisProductDetailsPopUpOpen}
        setShippingDetails={setShippingDetails}
        setProductDetails={setProductDetails}
      />
      <ShippingPopup
        isShippingPopUpOpen={isShippingPopUpOpen}
        setIsShippingPopUpOpen={setIsShippingPopUpOpen}
        shippingDetails={shippingDetails}
      />
      <ProductPopUp
        isProductDetailsPopUpOpen={isProductDetailsPopUpOpen}
        setisProductDetailsPopUpOpen={setisProductDetailsPopUpOpen}
        productDetails={productDetails}
      />
      {/* this for delete account popup */}
      <DeleteAccountPopUp
        isClickedToDelete={isClickedToDelete}
        setIsClickedToDelete={setIsClickedToDelete}
        DeleteAccount={DeleteAccount}
      />

      {/* this for user account information update */}
      {isClickedForUpdate && (
        <UpdateProfile
          updateAccountInfo={updateAccountInfo}
          setUpdateAccountInfo={setUpdateAccountInfo}
          setIsClickedForUpdate={setIsClickedForUpdate}
        />
      )}
    </div>
  );
};

export default Personalinfo;
